import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for the records bulk comment workflow.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Opens the bulk comment modal for the current selection */
    initiate: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.onInitiate(),
    }),
    /** Closes the bulk comment modal without applying anything */
    cancel: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.INITIAL,
    }),
    /** Stores the comment being edited */
    setComment: store.actions.standalone({
      data: store.actions.Data.asIs<string>(),
      reducer: ({ state, data: comment }) => ({ ...state, comment }),
    }),
    /**
     * Applies the edited comment to every selected record.
     *
     * Cancelled by its effect when there is nothing to apply it to.
     */
    submit: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ state }) => State.onRequest(state),
        success: () => State.INITIAL,
        error: ({ state, data: { error } }) => State.onError(error, state),
        cancellation: ({ state }) => State.onCancellation(state),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
